<template lang="pug">
OrderActionModal(v-if="item" :show="show" max-width="min(100vw - 2rem, 28rem)" @close="onClose")
  template(slot="header")
    .transfer-modal__modal-title.uppercase {{ pickedTier }}
  .transfer-modal
    .transfer-modal__product-row
      .transfer-modal__product
        InventoryProduct(
          :reference="item.product"
          :size="item.size"
          :quantity="item.quantity"
          :brand="item.brand"
          :folder="item.folder"
          :subfolder="item.subfolder"
          :image="item.image"
        )

    .transfer-modal__section
      .transfer-modal__title Devolver a:
      .transfer-modal__tiers
        button.transfer-modal__tier(
          type="button"
          :disabled="busy"
          @click="onSelect(baseTier)"
        ) {{ baseTier }}
        button.transfer-modal__tier(
          v-if="pickedTier !== baseTier"
          type="button"
          :disabled="busy"
          @click="onSelect(pickedTier)"
        ) {{ pickedTier }}
</template>

<script>
import OrderActionModal from '@/components/pages/order/refund/OrderActionModal.vue'
import InventoryProduct from '@/components/pages/inventory/edit/Product.vue'
import { getBaseTierByBrand } from '@/helpers/tier'

export default {
  name: 'UnpickTierModal',

  components: {
    OrderActionModal,
    InventoryProduct
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    pickedTier: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: null
    },
    busy: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    baseTier () {
      return getBaseTierByBrand(this.item && this.item.brand)
    }
  },

  methods: {
    onClose () {
      if (this.busy) return
      this.$emit('close')
    },

    onSelect (returnTier) {
      if (this.busy) return
      this.$emit('select', returnTier)
    }
  }
}
</script>

<style lang="stylus" scoped>
.transfer-modal
  padding 0 1.5rem 1.5rem
  overflow-y auto

.transfer-modal__modal-title
  font-size 1.5em
  font-weight 700

.transfer-modal__product-row
  display flex
  align-items flex-end
  gap 1rem
  margin-bottom 1.25rem

.transfer-modal__product
  flex 0 0 12rem
  max-width 12rem

.transfer-modal__section
  margin-top 1.25rem

.transfer-modal__title
  font-size 1rem
  font-weight 600
  text-transform uppercase
  margin-bottom .65rem

.transfer-modal__tiers
  display flex
  flex-wrap wrap
  gap .5em

.transfer-modal__tier
  font-family inherit
  font-size 1em
  font-weight 600
  text-transform uppercase
  padding .35em .65em
  background-color #e9e9e7
  border none
  cursor pointer

  &:hover
    opacity .75

  &:disabled
    opacity .35
    cursor not-allowed
</style>



// WEBPACK FOOTER //
// src/components/pages/order/UnpickTierModal.vue